<template>
  <div>
    <div class="prizes-top">
      <div>
        <div class="prize-code-inputs">
          <input
            class="user-app-code-input-field"
            type="text"
            maxlength="1"
            v-model="first"
            @keyup="
              moveToNext($event, {
                previousIndex: null,
                currentIndex: 0,
                nextIndex: 1,
              })
            "
          />
          <input
            class="user-app-code-input-field"
            type="text"
            maxlength="1"
            v-model="second"
            @keyup="
              moveToNext($event, {
                previousIndex: 0,
                currentIndex: 1,
                nextIndex: 2,
              })
            "
          />
          <input
            class="user-app-code-input-field"
            type="text"
            maxlength="1"
            v-model="third"
            @keyup="
              moveToNext($event, {
                previousIndex: 1,
                currentIndex: 2,
                nextIndex: 3,
              })
            "
          />
          <input
            class="user-app-code-input-field"
            type="text"
            maxlength="1"
            v-model="fourth"
            @keyup="
              moveToNext($event, {
                previousIndex: 2,
                currentIndex: 3,
                nextIndex: 4,
              })
            "
          />
          <input
            class="user-app-code-input-field"
            type="text"
            maxlength="1"
            v-model="fifth"
            @keyup="
              moveToNext($event, {
                previousIndex: 3,
                currentIndex: 4,
                nextIndex: 5,
              })
            "
          />
          <input
            class="user-app-code-input-field"
            type="text"
            maxlength="1"
            v-model="sixth"
            @keyup="
              moveToNext($event, {
                previousIndex: 4,
                currentIndex: 5,
                nextIndex: null,
              })
            "
          />
        </div>
        <div class="enter-code">Unesi kod</div>
        <div class="enter-code-help">Ne brini, jedem i mala slova</div>
      </div>
      <div>
        <animated-number
          class="user-points"
          v-if="points !== null"
          v-bind:value="points"
          v-bind:round="true"
          v-bind:duration="800"
        />
        <div class="user-points" v-else>-</div>
        <div class="user-points-label">Ukupan broj bodova</div>
      </div>
    </div>
    <div class="added-points" v-bind:style="{ visibility: pointsAdded > 0 ? 'visible' : 'hidden' }">
      Dodano {{ pointsAdded }} bodova.
    </div>

    <div
      v-bind:style="{
        visibility: progressBarWidth !== null ? 'visible' : 'hidden',
      }"
      class="progress-bar-container"
    >
      <div v-bind:style="{ width: `${progressBarWidth}px` }" class="progress-bar-fill"></div>

      <div class="milestone" @mouseover="mouseover(1)" @mouseleave="mouseleave(1)">
        <hr class="line" />
        <div class="image-container">
          <div class="progress-bar-icon"></div>
        </div>
        <div class="milestone-popup" v-if="arePopupsOpen[1]">
          <div class="popup-header">
            <span class="popup-title">3, 2, 1… takeoff</span>
            <div class="popup-header-right">
              <div class="popup-star-container">
                <div class="popup-star" />
              </div>
              <span class="popup-points">200</span>
            </div>
          </div>
          <p class="popup-text">Sad već pričamo! Samo tako nastavi i nagrada je tvoja!</p>
        </div>
        <span class="popup-triangle" v-if="arePopupsOpen[1]"></span>
      </div>
      <div class="milestone" @mouseover="mouseover(2)" @mouseleave="mouseleave(2)">
        <hr class="line" />
        <div class="image-container">
          <div class="progress-bar-icon"></div>
        </div>
        <div class="milestone-popup" v-if="arePopupsOpen[2]">
          <div class="popup-header">
            <span class="popup-title">You are out of this world</span>
            <div class="popup-header-right">
              <div class="popup-star-container">
                <div class="popup-star" />
              </div>
              <span class="popup-points">400</span>
            </div>
          </div>
          <p>Još malo pa pola puta (a onda samo još jednom toliko) :D</p>
        </div>
        <span v-if="arePopupsOpen[2]" class="popup-triangle"></span>
      </div>
      <div class="milestone" @mouseover="mouseover(3)" @mouseleave="mouseleave(3)">
        <hr class="line" />
        <div class="image-container">
          <div class="progress-bar-icon"></div>
        </div>
        <div class="milestone-popup" v-if="arePopupsOpen[3]">
          <div class="popup-header">
            <span class="popup-title">Rocketing through this!</span>
            <div class="popup-header-right">
              <div class="popup-star-container">
                <div class="popup-star" />
              </div>
              <span class="popup-points">600</span>
            </div>
          </div>
          <p>Nebo je nekad bila granica, a tebe ni svemir ne može zadržati!</p>
        </div>
        <span class="popup-triangle" v-if="arePopupsOpen[3]"></span>
      </div>
      <div class="milestone" @mouseover="mouseover(4)" @mouseleave="mouseleave(4)">
        <hr class="line" />
        <div class="image-container">
          <div class="progress-bar-icon"></div>
        </div>
        <div class="milestone-popup" v-if="arePopupsOpen[4]">
          <div class="popup-header">
            <span class="popup-title">Finish line in sight</span>
            <div class="popup-header-right">
              <div class="popup-star-container">
                <div class="popup-star" />
              </div>
              <span class="popup-points">800</span>
            </div>
          </div>
          <p>Kraj te se boji, opasno mu se približavaš!</p>
        </div>
        <span class="popup-triangle" v-if="arePopupsOpen[4]"></span>
      </div>
      <div class="milestone" @mouseover="mouseover(5)" @mouseleave="mouseleave(5)">
        <hr class="line" />
        <div class="image-container">
          <div class="progress-bar-icon"></div>
        </div>
        <div class="milestone-popup" v-if="arePopupsOpen[5]">
          <div class="popup-header">
            <span class="popup-title">The end?</span>
            <div class="popup-header-right">
              <div class="popup-star-container">
                <div class="popup-star" />
              </div>
              <span class="popup-points">1000</span>
            </div>
          </div>
          <p>
            Ako si mislio da je ovdje priči kraj - grdno se varaš! Toliko toga za vidjeti, a tako malo vremena.
            Iskoristi još malo vremena što imaš - svaki bod je korak bliže glavnoj nagradi.
          </p>
        </div>
        <span v-if="arePopupsOpen[5]" class="popup-triangle"></span>
      </div>
      <div class="milestone" @mouseover="mouseover(0)" @mouseleave="mouseleave(0)">
        <div class="image-container">
          <div class="progress-bar-icon"></div>
        </div>
        <div class="milestone-popup" v-if="arePopupsOpen[0]">
          <div class="popup-header">
            <span class="popup-title">Working hard or hardly working?</span>
            <div class="popup-header-right">
              <div class="popup-star-container">
                <div class="popup-star" />
              </div>
              <span class="popup-points">1</span>
            </div>
          </div>
          <p>1 point? Those are rookie numbers! :D</p>
        </div>
        <span v-if="arePopupsOpen[0]" class="popup-triangle"></span>
      </div>
    </div>
  </div>
</template>

<script>
import AnimatedNumber from 'animated-number-vue';
export default {
  name: 'PrizesCodes',
  components: {
    AnimatedNumber,
  },
  data() {
    return {
      points: null,
      pointsAdded: 0,
      first: '',
      second: '',
      third: '',
      fourth: '',
      fifth: '',
      sixth: '',
      progressBarWidth: null,
      arePopupsOpen: [false, false, false, false, false, false],
    };
  },
  methods: {
    mouseover: function (index) {
      this.$set(this.arePopupsOpen, index, true);
    },
    mouseleave: function (index) {
      this.$set(this.arePopupsOpen, index, false);
    },
    moveToNext: function (event, { previousIndex, currentIndex, nextIndex }) {
      const inputFields = document.getElementsByClassName('user-app-code-input-field');
      const currentInputField = inputFields[currentIndex];

      if (event.key === 'Backspace' && previousIndex !== null) {
        currentInputField.classList.remove('user-app-code-input-field__filled');
        inputFields[previousIndex].focus();

        return;
      }

      if (currentInputField.value.length && nextIndex !== null) {
        currentInputField.classList.add('user-app-code-input-field__filled');
        inputFields[nextIndex].focus();

        return;
      }

      if (currentInputField.value.length && nextIndex === null) {
        this.sendRequestIfAllFilled();
      }
    },
    sendRequestIfAllFilled: function () {
      if (
        !this.first.length ||
        !this.second.length ||
        !this.third.length ||
        !this.fourth.length ||
        !this.fifth.length ||
        !this.sixth.length
      ) {
        return;
      }
      if (
        this.first.length !== 1 ||
        this.second.length !== 1 ||
        this.third.length !== 1 ||
        this.fourth.length !== 1 ||
        this.fifth.length !== 1 ||
        this.sixth.length !== 1
      ) {
        return;
      }

      const wholeCode = (this.first + this.second + this.third + this.fourth + this.fifth + this.sixth).toUpperCase();

      this.$axios
        .post(`${this.$API_URL}/user/enter-code`, {
          code: wholeCode,
        })
        .then(response => {
          const pointsToAdd = response.data.item1;

          this.points += pointsToAdd;
          this.pointsAdded += pointsToAdd;

          setTimeout(() => (this.pointsAdded = 0), 3000);
          let achievementToAddIds = response.data.item2;
          this.$emit('onAddedAchievement', achievementToAddIds);
          this.first = '';
          this.second = '';
          this.third = '';
          this.fourth = '';
          this.fifth = '';
          this.sixth = '';
        })
        .catch(() => {
          alert('Unos neuspješan. Neispravan (ili već unesen) kod ili nemaš dopuštenje.');

          const inputElements = document.getElementsByClassName('user-app-code-input-field');

          inputElements[0].focus();

          inputElements.forEach(element => {
            element.classList.remove('user-app-code-input-field__filled');
          });
        });

      this.first = '';
      this.second = '';
      this.third = '';
      this.fourth = '';
      this.fifth = '';
      this.sixth = '';
    },
  },
  created() {
    this.$axios.get(`${this.$API_URL}/user/points`).then(response => {
      this.points = response.data;
      this.progressBarWidth = (response.data / 1050) * this.progressBarContainer.offsetWidth;

      const numberOfActiveIcons = 0;

      if (response.data !== 0) {
        numberOfActiveIcons = (response.data - (response.data % 200)) / 200 + 1;
      } else if (response.data >= 1000) {
        numberOfActiveIcons = 6;
      }

      const milestoneElements = document.getElementsByClassName('progress-bar-icon');
      const lines = document.getElementsByClassName('line');
      const milestone = document.getElementsByClassName('milestone');

      if (numberOfActiveIcons > 0) {
        milestoneElements[5].style.background = '#5ec4bc';
        milestone[5].classList.add('active');
      }

      for (let i = 0; i < numberOfActiveIcons - 1; i++) {
        milestone[i].classList.add('active');
        milestoneElements[i].style.background = '#5ec4bc';
        lines[i].style.background = '#5ec4bc';
      }

      for (let i = 0; i < milestoneElements.length; i++) {
        milestoneElements[i].style.fill = '#5ec4bc';
      }

      const progressBarModals = document.getElementsByClassName('milestone-popup');

      for (let i = 0; i < progressBarModals.length; i++) {
        if (i < numberOfActiveIcons) {
          progressBarModals[i].getElementsByClassName('popup-star')[0].style.backgroundColor = '#5ec4bc';
        }

        progressBarModals[i].style.display = 'none';
      }
    });
  },
  mounted() {
    this.progressBarContainer = document.querySelector('.progress-bar-container');
  },
};
</script>

<style scoped>
.prizes-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}

.user-points {
  display: block;
  font-weight: 800;
  font-size: 48px;
  line-height: 58px;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 64px;
  margin-bottom: 6px;
}

.user-points-label {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
}

.prize-code-inputs {
  width: 100%;
  display: flex;
  justify-content: center;
}

.user-app-code-input-field {
  box-sizing: border-box;
  width: 48px;
  height: 56px;
  border: 2px solid #fff;
  border-radius: 8px;
  text-transform: uppercase;
  background-color: transparent;
  font-weight: 800;
  font-size: 24px;
  line-height: 29px;
  text-align: center;
  color: #ffffff;
}

.user-app-code-input-field:not(:last-child) {
  margin-right: 8px;
}

.user-app-code-input-field__filled {
  border-color: rgba(255, 255, 255, 0.5);
}

input:focus {
  color: #5ec4bc;
  border: 2px solid #5ec4bc;
  outline: none;
}

.enter-code {
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #ffffff;
  margin: 0;
  margin-top: 16px;
}

.enter-code-help {
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 0;
  margin-bottom: 0;
}

@media screen and (min-width: 1023px) {
  .prizes-top {
    flex-direction: row;
  }

  .user-points {
    margin-top: 0;
  }

  .user-app-code-input-field {
    width: 70px;
    height: 80px;
    font-size: 32px;
    line-height: 38px;
  }
}

.progress-bar-container {
  position: relative;
  margin: auto;
  margin-top: 350px;
  margin-bottom: 250px;
  border-radius: 4px;
  height: 4px;
  background-color: rgba(255, 255, 255, 0.5);
}

.image-container {
  width: 48px;
  height: 48px;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 5px;
  display: flex;
  justify-content: center;
}

.milestone .progress-bar-icon {
  width: 100%;
  background: #ffffff;
  mask-size: 24px;
}

.milestone-icon {
  filter: brightness(0) saturate(100%);
  opacity: 0.25;
  width: 20px;
  height: 20px;
}
.milestone:nth-of-type(odd) {
  top: -57px;
  flex-direction: column-reverse;
}
.milestone:nth-of-type(even) {
  bottom: -57px;
  flex-direction: column;
}

@media screen and (min-width: 1023px) {
  .image-container {
    width: 64px;
    height: 64px;
  }

  .milestone .progress-bar-icon {
    mask-size: 32px;
  }

  .milestone:nth-of-type(odd) {
    top: -75px;
  }

  .milestone:nth-of-type(even) {
    bottom: -75px;
  }
}

.milestone:nth-of-type(2) .progress-bar-icon {
  mask: url('../../../assets/app-icons/prizes/prize-bar/job.svg') no-repeat center;
}
.milestone:nth-of-type(3) .progress-bar-icon {
  mask: url('../../../assets/app-icons/prizes/prize-bar/spaceship.svg') no-repeat center;
}
.milestone:nth-of-type(4) .progress-bar-icon {
  mask: url('../../../assets/app-icons/prizes/prize-bar/astronaut.svg') no-repeat center;
}
.milestone:nth-of-type(5) .progress-bar-icon {
  mask: url('../../../assets/app-icons/prizes/prize-bar/comet.svg') no-repeat center;
}
.milestone:nth-of-type(6) .progress-bar-icon {
  mask: url('../../../assets/app-icons/prizes/prize-bar/lunar-flag.svg') no-repeat center;
}
.milestone:nth-of-type(7) .progress-bar-icon {
  mask: url('../../../assets/app-icons/prizes/prize-bar/planet.svg') no-repeat center;
}
.popup-star-container {
  width: 28px;
  height: 20px;
  display: flex;
  align-items: center;
}
.popup-header-right .popup-star {
  mask: url('../../../assets/app-icons/prizes/prize-bar/star.svg') no-repeat center;
  mask-size: 18px;
  background-color: #cfd8dd;
  width: 100%;
  height: 100%;
  transform: translateY(1px);
}
.milestone.active .popup-header-right .popup-star {
  background-color: #5ec4bc;
}
.progress-bar-fill {
  border-radius: 8px;
  height: 100%;
  background-color: #30cec1;
  max-width: 100%;
  z-index: 3;
}
.milestone {
  position: absolute;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.milestone-popup {
  width: max-content;
  position: absolute;
  background: #162426;
  border-radius: 10px;
  padding: 30px 22px;
  font-size: 18px;
  color: #7a8e94;
  z-index: 2;
}

.milestone-popup p {
  max-width: 260px;
}

.milestone:nth-of-type(even) .milestone-popup {
  bottom: 130px;
}

.milestone:nth-of-type(odd) .milestone-popup {
  bottom: 96px;
}

.milestone:nth-of-type(6) .milestone-popup {
  right: 0px;
  bottom: 130px;
}

.milestone:nth-of-type(7) .milestone-popup {
  bottom: 70px;
  left: 0px;
}

.milestone .popup-triangle {
  top: -68px;
}

.milestone:nth-of-type(odd) .popup-triangle {
  top: -34px;
}

@media screen and (max-width: 600px) {
  .milestone:nth-of-type(7) .milestone-popup {
    left: -20px;
  }
  .milestone:nth-of-type(2) .milestone-popup {
    left: -54px;
  }
  .milestone:nth-of-type(3) .milestone-popup {
    left: -100px;
  }
  .milestone:nth-of-type(4) .milestone-popup {
    right: -100px;
  }
  .milestone:nth-of-type(5) .milestone-popup {
    right: -54px;
  }
}

@media screen and (min-width: 1023px) {
  .milestone:nth-of-type(odd) .milestone-popup {
    bottom: 108px;
  }

  .milestone:nth-of-type(even) .milestone-popup {
    bottom: 160px;
  }

  .milestone:nth-of-type(7) .milestone-popup {
    bottom: 82px;
  }

  .milestone .popup-triangle {
    top: -82px;
  }

  .milestone:nth-of-type(odd) .popup-triangle {
    top: -32px;
  }
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.popup-title {
  color: #ffffff;
}
.milestone p {
  color: rgba(255, 255, 255, 0.8);
}
.popup-header-right {
  display: flex;
  align-items: center;
  font-size: 20px;
}
.popup-points {
  padding-top: 3px;
  color: #cfd8dd;
}
.milestone hr {
  transform: rotate(90deg);
  width: 8px;
  height: 1px;
  margin: 12px 0;
  background-color: #cfd8dd;
  border: 0px;
}
.popup-triangle {
  position: absolute;
  width: 20px;
  height: 20px;
  transform: rotate(45deg);
  background: #162426;
  border-radius: 2px;
  z-index: 2;
}
.milestone:nth-of-type(2) {
  left: 13%;
}
.milestone:nth-of-type(3) {
  left: 32%;
}
.milestone:nth-of-type(4) {
  left: 51%;
}
.milestone:nth-of-type(5) {
  left: 70%;
}
.milestone:nth-of-type(6) {
  left: 89%;
}
.milestone.active img {
  filter: invert(78%) sepia(9%) saturate(3087%) hue-rotate(121deg) brightness(92%) contrast(83%);
  opacity: 1;
}
.ddays-logo {
  display: none;
}
.added-points {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #30cec2;
}

@media screen and (max-width: 1440px) {
  .progress-bar-container {
    margin-top: 300px;
    margin-bottom: 160px;
  }
}

@media screen and (max-width: 1096px) {
  .progress-bar-container {
    margin-top: 170px;
    margin-bottom: 140px;
  }

  .prizes-wrapper {
    margin: 0 -25px;
  }
  .achievements-wrapper {
    margin: 42px -25px 0 -25px;
  }
  .achievements-wrapper .slider {
    padding: 25px 25px 150px 25px;
  }
  .achievements-wrapper .achievement-box:last-of-type::after {
    right: -25px;
    width: 25px;
  }
}

@media screen and (max-width: 1024px) {
  .ddays-logo {
    position: absolute;
    display: block;
    right: 7%;
    top: 83px;
  }
}

@media screen and (max-width: 768px) {
  #user-app-prizes {
    padding: 75px 20px 75px 60px;
  }

  .progress-bar-icon {
    mask-size: 20px;
  }
}

@media screen and (max-width: 550px) {
  .achievements-wrapper {
    margin-top: 14px;
  }
  .achievements-wrapper .slider {
    padding-bottom: 50px;
  }
  .achievements-wrapper .achievement-box {
    min-width: 214px;
    height: 158px;
    padding: 19px 16px 44px 16px;
    margin-left: 14px;
  }
  .achievements-wrapper .achievement-box .achievement-name {
    margin-bottom: 2px;
    font-size: 16px;
    line-height: 19px;
  }
  .prizes-wrapper .prize {
    margin-left: 24px;
  }
  .prizes-wrapper .prize .prize-caption {
    width: 180px;
  }
  .prizes-wrapper .prize .prize-label {
    font-size: 14px;
  }
  input:focus {
    border-width: 1px;
  }

  .progress-bar-icon {
    mask-size: 20px !important;
  }

  .progress-bar-container {
    height: 3px;
  }

  .milestone hr {
    height: 1px;
    width: 14px;
  }

  .popup-title {
    font-size: 16px;
    margin-right: 8px;
  }

  .popup-header-right {
    font-size: 16px;
  }
}
@media screen and (max-width: 375px) {
  .popup-title,
  .popup-points {
    font-size: 14px;
  }

  .user-app-code-input-field {
    width: 40px;
    height: 48px;
  }
}
</style>
